import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigManager/constants";

export const clearSiteGroups = createAction(`${moduleSlug}/CLEAR_SITE_GROUPS`);

export const getSiteGroups = createAction(`${moduleSlug}/GET_SITE_GROUPS`);
export const getSiteGroupsSuccess = createAction(`${moduleSlug}/GET_SITE_GROUPS/SUCCESS`);
export const getSiteGroupsError = createAction(`${moduleSlug}/GET_SITE_GROUPS/ERROR`);

export const setSiteGroupFormDialog = createAction(`${moduleSlug}/SET_SITE_GROUP_FORM_DIALOG`);

export const createSiteGroup = createAction(`${moduleSlug}/CREATE_SITE_GROUP`);

export const editSiteGroup = createAction(`${moduleSlug}/EDIT_SITE_GROUP`);
export const deleteSiteGroup = createAction(`${moduleSlug}/DELETE_SITE_GROUP`);
